import {TextField} from '@material-ui/core';
import {Autocomplete} from '@material-ui/lab';
import {withStyles} from '@material-ui/styles';
import React from 'react';
import {useEffect} from 'react';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import connect from 'react-redux/es/connect/connect';
import {deliveryActions} from '../../../../_actions';
import FormField from '../../../Authorization/FormField';
import {v4 as uuid} from 'uuid';
import {StepSelector} from '../StepSelector';
import axInst from '../../../../_helpers/axios-instance';

const Input = withStyles({
  root: {
    borderRadius: 40,
    background: '#EBF0F8',
    border: 'none',

    '& .MuiInputBase-input': {
      marginLeft: 25,
      fontSize: 13,
    },
    '& .MuiFormLabel-root': {
      left: 15,
      color: '#000',

      '&.Mui-focused': {
        color: '#315EFB',
      },
      '&.MuiInputLabel-shrink': {
        color: '#315EFB',
      },
    },

    '& .MuiFilledInput-root': {
      background: 'transparent',
    },
    '& .MuiFilledInput-underline:after': {
      border: 'none',
      content: '',
    },
    '& .MuiFilledInput-underline:before': {
      border: 'none',
      content: '',
    },
  },
})(TextField);

const ThirdStep = props => {
  const {
    setDisableBtn,
    activeStep,
    getListDeliveryService,
    listDeliveryServices,
    customer,
    formState,
    setFormState,
    setReturnMethod,
    returnMethod,
  } = props;

  const [hideAnotherFields, setHideAnotherFields] = useState(true);
  const [returnMethodArray, setReturnMethodArray] = useState([]);
  const [isNovaPoshta, setIsNovaPoshta] = useState(false);
  const [isLoadingTTN, setIsLoadingTTN] = useState(false);
  const [ttnError, setTtnError] = useState('');
  const [showPhoneField, setShowPhoneField] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneSubmitted, setPhoneSubmitted] = useState(false);
  const [fieldsFilledFromApi, setFieldsFilledFromApi] = useState({
    placeCount: false,
    otpravitel: false,
    poluchatel: false,
    price: false,
    user: false,
  });
  const {t} = useTranslation();

  const getTrackingInfo = async (ttnNumber, phone) => {
    setIsLoadingTTN(true);
    setTtnError('');

    try {
      const response = await fetch('https://api.novaposhta.ua/v2.0/json/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          apiKey: 'edc88d8e0fb1813f4c4fb0d5301c27d8',
          modelName: 'TrackingDocumentGeneral',
          calledMethod: 'getStatusDocuments',
          methodProperties: {
            Documents: [
              {
                DocumentNumber: ttnNumber,
                Phone: phone,
              },
            ],
          },
        }),
      });

      const data = await response.json();

      if (data.success && data.data && data.data.length > 0) {
        const trackingData = data.data[0];

        setFormState(prevState => ({
          ...prevState,
          values: {
            ...prevState.values,
            placeCount: trackingData.SeatsAmount || '1',
            otpravitel: trackingData.SenderFullNameEW || '',
            poluchatel: trackingData.RecipientFullName || '',
            price: trackingData.DocumentCost || '',
            user:
              trackingData.PayerType === 'Sender'
                ? t('common:Sender')
                : t('common:Recipient'),
          },
        }));

        setFieldsFilledFromApi({
          placeCount: !!trackingData.SeatsAmount,
          otpravitel: !!trackingData.SenderFullNameEW,
          poluchatel: !!trackingData.RecipientFullName,
          price: !!trackingData.DocumentCost,
          user: !!trackingData.PayerType,
        });

        setHideAnotherFields(false);
        setPhoneSubmitted(true);
      } else {
        setTtnError(t('common:ttn_not_found'));
      }
    } catch (error) {
      console.error('Ошибка при получении данных ТТН:', error);
      setTtnError(t('common:ttn_fetch_error'));
    } finally {
      setIsLoadingTTN(false);
    }
  };

  let cariers = listDeliveryServices?.data
    ? [
        ...listDeliveryServices.data.map(item => ({...item, _uuid: uuid()})),
        {name: 'Доставка на склад DaniParts', _uuid: uuid()},
        {name: 'Передача курьером DaniParts', _uuid: uuid()},
      ]
    : [
        {name: 'Доставка на склад DaniParts'},
        {name: 'Передача курьером DaniParts'},
      ];

  useEffect(() => {
    if (activeStep === 2) {
      if (returnMethod == 4 || returnMethod == 5) {
        setDisableBtn(false);
        setHideAnotherFields(true);
      } else if (returnMethod == 6) {
        if (phoneSubmitted) {
          if (
            formState.values.otpravitel &&
            formState.values.placeCount &&
            formState.values.poluchatel &&
            formState.values.price &&
            formState.values.ttnNumber &&
            formState.values.user &&
            formState?.values?.ttnNumber.length == 14 &&
            formState?.values?.otpravitel.split(' ')[1]?.length > 2
          ) {
            setDisableBtn(false);
          } else {
            setDisableBtn(true);
          }
        } else {
          setDisableBtn(true);
        }
      }
    }
  }, [formState, activeStep, returnMethod, phoneSubmitted]);

  useEffect(() => {
    try {
      setHideAnotherFields(true);
      axInst.post('/api/get-feedback-data/', {}).then(data => {
        setReturnMethodArray(data.data.return_method);
      });
      getListDeliveryService();
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleChange = (event, variant) => {
    event.persist();

    if (variant === 'no-text') {
      if (/[^0-9]+/g.test(event.target.value)) {
        return;
      }
    }

    const fieldName = event.target.name;
    const fieldValue =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;

    if (fieldName === 'phone') {
      setPhoneNumber(fieldValue);
      return;
    }

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [fieldName]: fieldValue,
      },
      touched: {
        ...formState.touched,
        [fieldName]: true,
      },
    }));

    if (fieldName === 'ttnNumber' && isNovaPoshta) {
      if (fieldValue.length === 14) {
        setShowPhoneField(true);
      } else {
        setShowPhoneField(false);
        setHideAnotherFields(true);
        setPhoneSubmitted(false);
      }
    }
  };

  const handleChangeAutocomplete = (e, data, name) => {
    setFormState({
      ...formState,
      values: {
        ...formState.values,
        [name]: data,
      },
    });
  };

  const handlePhoneSubmit = () => {
    if (phoneNumber && formState.values.ttnNumber) {
      getTrackingInfo(formState.values.ttnNumber, phoneNumber);
    } else {
      setTtnError(t('common:enter_phone_and_ttn'));
    }
  };

  const handleCarrierChange = (e, data, reason) => {
    handleChangeAutocomplete(e, data, 'selectCarrier');

    const isNovaPoshtaSelected =
      data &&
      (data.name?.toLowerCase().includes('нова пошта') ||
        data.name?.toLowerCase().includes('nova poshta'));

    setIsNovaPoshta(isNovaPoshtaSelected);
    setShowPhoneField(false);
    setPhoneSubmitted(false);
    setPhoneNumber('');

    if (reason == 'clear') {
      setHideAnotherFields(true);
      setReturnMethod(null);
      setIsNovaPoshta(false);
      setFormState(prevState => ({
        ...prevState,
        values: {
          ...prevState.values,
          ttnNumber: '',
          placeCount: '',
          user: '',
          otpravitel: '',
          poluchatel: '',
          price: '',
        },
      }));
    }
  };

  return (
    <div className="no-scroll">
      <Autocomplete
        id="combo-box-demo"
        options={returnMethodArray}
        getOptionLabel={option => option?.name}
        style={{borderRadius: '40px', marginBottom: 20}}
        onChange={handleCarrierChange}
        disabled={phoneSubmitted}
        renderOption={option => (
          <div
            style={{width: '100%'}}
            onClick={() => setReturnMethod(option.id)}>
            {option?.name}
          </div>
        )}
        renderInput={params => (
          <Input
            {...params}
            label={t('common:select_a_carrier')}
            variant="filled"
            disabled={phoneSubmitted}
          />
        )}
      />

      {!hideAnotherFields || isNovaPoshta ? (
        <>
          <div className="row mx-0" style={{marginBottom: '20px'}}>
            <div className="user-form p-0 col-6 pr-1">
              <FormField
                style={{width: '100%'}}
                name="ttnNumber"
                type="text"
                variant="no-text"
                handleChange={handleChange}
                formState={formState}
                title={t('common:TTN_number')}
                hasErrorText={t('common:enter_email2')}
                disabled={phoneSubmitted && isNovaPoshta}
              />
              {formState?.values?.ttnNumber.length != 14 &&
                formState?.values?.ttnNumber.length > 0 && (
                  <div
                    className="help-block"
                    style={{
                      color: 'red',
                      paddingLeft: '20px',
                      paddingBottom: '10px',
                    }}>
                    {t('common:TTN_length')}
                  </div>
                )}
              {ttnError && (
                <div
                  className="help-block"
                  style={{
                    color: 'red',
                    paddingLeft: '20px',
                    paddingBottom: '10px',
                  }}>
                  {ttnError}
                </div>
              )}
              {isLoadingTTN && (
                <div
                  className="help-block"
                  style={{
                    color: 'blue',
                    paddingLeft: '20px',
                    paddingBottom: '10px',
                  }}>
                  {t('common:ttn_loading')}
                </div>
              )}
            </div>
            {showPhoneField && (
              <div className="user-form p-0 col-6 pl-1">
                <FormField
                  name="phone"
                  type="text"
                  variant="no-text"
                  handleChange={handleChange}
                  formState={{values: {phone: phoneNumber}, touched: {}}}
                  title={t('common:Phone')}
                  hasErrorText={t('common:enter_phone')}
                  disabled={false}
                />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '100%',
                  }}>
                  <button
                    onClick={handlePhoneSubmit}
                    style={{
                      maxWidth: 'max-content',
                      padding: '8px 16px',
                      backgroundColor:
                        !phoneNumber || phoneNumber.length < 10
                          ? '#E0E0E0'
                          : '#FFBE00',
                      color:
                        !phoneNumber || phoneNumber.length < 10
                          ? '#A0A0A0'
                          : '#1F1F1F',
                      border: 'none',
                      borderRadius: '12px',
                      cursor:
                        !phoneNumber || phoneNumber.length < 10
                          ? 'not-allowed'
                          : 'pointer',
                      boxSizing: 'border-box',
                      opacity:
                        !phoneNumber || phoneNumber.length < 10 ? 0.6 : 1,
                      transition:
                        'background-color 0.3s, color 0.3s, opacity 0.3s',
                    }}
                    disabled={!phoneNumber || phoneNumber.length < 10}>
                    {t('common:ttn_review')}
                  </button>
                </div>
              </div>
            )}
          </div>

          {(phoneSubmitted || !isNovaPoshta) && !hideAnotherFields && (
            <>
              <div className="row mx-0" style={{marginBottom: '20px'}}>
                <div className="user-form p-0 col-6 pr-1">
                  <Autocomplete
                    id="combo-box-demo"
                    options={[
                      `1 ${t('common:months')}`,
                      `2 ${t('common:months')}`,
                      `3 ${t('common:months')}`,
                      `4 ${t('common:months')}`,
                      `5 ${t('common:months')}`,
                    ]}
                    getOptionLabel={option => option}
                    style={{borderRadius: '40px'}}
                    value={formState.values.placeCount || null}
                    disabled={
                      phoneSubmitted &&
                      isNovaPoshta &&
                      fieldsFilledFromApi.placeCount
                    }
                    onChange={(e, data) =>
                      handleChangeAutocomplete(e, data, 'placeCount')
                    }
                    renderInput={params => (
                      <Input
                        {...params}
                        label={t('common:number_of_seats')}
                        variant="filled"
                        disabled={
                          phoneSubmitted &&
                          isNovaPoshta &&
                          fieldsFilledFromApi.placeCount
                        }
                      />
                    )}
                  />
                </div>
                <div className="user-form p-0 col-6 pl-1">
                  <Autocomplete
                    id="combo-box-demo"
                    options={[t('common:Recipient'), t('common:Sender')]}
                    getOptionLabel={option => option}
                    style={{borderRadius: '40px'}}
                    value={formState.values.user || null}
                    disabled={
                      phoneSubmitted && isNovaPoshta && fieldsFilledFromApi.user
                    }
                    onChange={(e, data) =>
                      handleChangeAutocomplete(e, data, 'user')
                    }
                    renderInput={params => (
                      <Input
                        {...params}
                        label={t('common:Payer')}
                        variant="filled"
                        disabled={
                          phoneSubmitted &&
                          isNovaPoshta &&
                          fieldsFilledFromApi.user
                        }
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row mx-0" style={{marginBottom: '20px'}}>
                <div className="user-form p-0 col-6 pr-1">
                  <Input
                    name="otpravitel"
                    type="text"
                    value={formState.values.otpravitel || ''}
                    onChange={handleChange}
                    label={t('common:EnterSender')}
                    variant="filled"
                    disabled={
                      phoneSubmitted &&
                      isNovaPoshta &&
                      fieldsFilledFromApi.otpravitel
                    }
                    fullWidth
                  />
                  {!phoneSubmitted &&
                    !isNovaPoshta &&
                    (formState?.values?.otpravitel.split(' ').length < 2 ||
                      formState?.values?.otpravitel.split(' ').length > 3 ||
                      formState?.values?.otpravitel.split(' ')[0]?.length < 3 ||
                      formState?.values?.otpravitel.split(' ')[1]?.length < 3 ||
                      formState?.values?.otpravitel.split(' ')[2]?.length <
                        3) && (
                      <div
                        className="help-block"
                        style={{
                          color: 'red',
                          paddingLeft: '20px',
                          paddingBottom: '10px',
                        }}>
                        {t('common:fourthStepFormatName')}
                      </div>
                    )}
                </div>
                <div className="user-form p-0 col-6 pl-1">
                  <Autocomplete
                    id="combo-box-demo"
                    options={[
                      t('common:Igor_Tarasyuk'),
                      t('common:Demyanchuk_Boris'),
                    ]}
                    getOptionLabel={option => option}
                    style={{borderRadius: '40px'}}
                    value={formState.values.poluchatel || null}
                    disabled={
                      phoneSubmitted &&
                      isNovaPoshta &&
                      fieldsFilledFromApi.poluchatel
                    }
                    onChange={(e, data) =>
                      handleChangeAutocomplete(e, data, 'poluchatel')
                    }
                    renderInput={params => (
                      <Input
                        {...params}
                        label={t('common:Recipient')}
                        variant="filled"
                        disabled={
                          phoneSubmitted &&
                          isNovaPoshta &&
                          fieldsFilledFromApi.poluchatel
                        }
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row mx-0">
                <div className="user-form p-0 col-6 pr-1">
                  <Input
                    name="price"
                    type="text"
                    value={formState.values.price || ''}
                    onChange={e => handleChange(e, 'no-text')}
                    label={t('common:shipping_amount')}
                    variant="filled"
                    disabled={
                      phoneSubmitted &&
                      isNovaPoshta &&
                      fieldsFilledFromApi.price
                    }
                    fullWidth
                  />
                </div>
              </div>

              {formState.values.user && (
                <p className="wrong-text-bg" style={{marginTop: '20px'}}>
                  {t('common:return_text_when_select')}
                </p>
              )}
            </>
          )}
        </>
      ) : null}
    </div>
  );
};

const actionCreators = {
  getListDeliveryService: deliveryActions.getListDeliveryService,
};
const mapState = state => {
  const {listDeliveryServices, customer} = state;

  return {listDeliveryServices, customer};
};

export default connect(mapState, actionCreators)(ThirdStep);
